import { OpeningHours1Props } from "../../../props";
import { DaySchedule } from "./day-schedule";
import styles from "./opening-hours-variant-01.module.scss";

export const ScheduleColumn = ({
  title,
  schedule,
  id,
}: {
  title: string;
  schedule: any;
  id: string;
}) => (
  <div className={`${styles.column} column-${id}`}>
    <h2>{title}</h2>
    <ul className={`${styles.list} list-${id}`}>
      {Object.entries(schedule).map(([key, value]) => (
        <DaySchedule key={key} value={value as OpeningHours1Props} id={id} />
      ))}
    </ul>
  </div>
);
